module.exports = __webpack_public_path__ + "static/media/customer-services.911e88dd.jpg";